module.exports = __webpack_public_path__ + "img/img_nav_sale.85c73e61.svg";